// Zoom produit avec navigation entre les visuels
document.addEventListener('DOMContentLoaded', function () {
  const zoomModal = document.createElement('div');
  zoomModal.id = 'simple-zoom-modal';
  zoomModal.innerHTML = `
    <div class="zoom-overlay">
      <button type="button" class="zoom-nav zoom-nav--prev" aria-label="Image précédente">
        <span class="zoom-nav__icon" aria-hidden="true"></span>
      </button>
      <div class="zoom-content">
        <button type="button" class="zoom-close" aria-label="Fermer">&times;</button>
        <img class="zoom-image" src="" alt="">
        <video class="zoom-video" controls autoplay style="display: none;"></video>
      </div>
      <button type="button" class="zoom-nav zoom-nav--next" aria-label="Image suivante">
        <span class="zoom-nav__icon" aria-hidden="true"></span>
      </button>
    </div>
  `;
  document.body.appendChild(zoomModal);

  const style = document.createElement('style');
  style.textContent = `
    #simple-zoom-modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.9);
      z-index: 999999 !important;
      display: none;
      align-items: center;
      justify-content: center;
      opacity: 1;
      overflow: hidden;
    }

    .zoom-overlay {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;
      overflow: hidden;
      gap: 0.75rem;
      padding: 0 0.5rem;
      box-sizing: border-box;
    }

    .zoom-content {
      max-width: min(95vw, calc(100% - 7rem));
      max-height: 95%;
      position: relative;
      cursor: default;
      z-index: 1000000;
      overflow: hidden;
      flex: 0 1 auto;
    }

    .zoom-image,
    .zoom-video {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      overflow: hidden;
      user-select: none;
      -webkit-user-select: none;
      width: auto;
      height: auto;
      display: block;
      margin: 0 auto;
    }

    .zoom-nav {
      position: relative;
      flex: 0 0 auto;
      z-index: 1000002;
      background: rgba(255, 255, 255, 0.88);
      border: none;
      width: 2.8rem;
      height: 2.8rem;
      border-radius: 50%;
      cursor: pointer;
      display: none;
      align-items: center;
      justify-content: center;
      padding: 0;
      transition: background-color 0.2s ease;
    }

    .zoom-nav:hover {
      background: rgba(255, 255, 255, 1);
    }

    .zoom-nav__icon {
      display: block;
      width: 0.65rem;
      height: 0.65rem;
      border-right: 2px solid #333;
      border-bottom: 2px solid #333;
      transform: rotate(-45deg);
    }

    .zoom-nav--prev .zoom-nav__icon {
      transform: rotate(135deg);
      margin-left: 0.2rem;
    }

    .zoom-nav--next .zoom-nav__icon {
      margin-right: 0.2rem;
    }

    #simple-zoom-modal.is-open .zoom-nav {
      display: flex;
    }

    #simple-zoom-modal.is-single .zoom-nav {
      display: none !important;
    }

    @media screen and (min-width: 750px) {
      .zoom-content {
        max-width: min(98vw, calc(100% - 9rem));
        max-height: 98%;
      }

      .zoom-image,
      .zoom-video {
        max-width: 100%;
        max-height: 100vh;
      }

      .zoom-nav {
        width: 3.2rem;
        height: 3.2rem;
      }
    }

    .zoom-close {
      display: none !important;
    }
  `;
  document.head.appendChild(style);

  const zoomImage = zoomModal.querySelector('.zoom-image');
  const zoomVideo = zoomModal.querySelector('.zoom-video');
  const prevButton = zoomModal.querySelector('.zoom-nav--prev');
  const nextButton = zoomModal.querySelector('.zoom-nav--next');

  let galleryItems = [];
  let currentIndex = 0;
  let touchStartX = 0;

  function collectGalleryItems() {
    const mediaItems = document.querySelectorAll('.product__media-list .product__media-item');
    const items = [];

    mediaItems.forEach(function (mediaItem) {
      const video = mediaItem.querySelector('video');
      const img = mediaItem.querySelector('.product__media img');

      if (video) {
        let videoSrc = video.currentSrc || video.src;
        if (!videoSrc) {
          const source = video.querySelector('source');
          if (source) videoSrc = source.src;
        }
        if (videoSrc) {
          items.push({ type: 'video', src: videoSrc, alt: '', element: mediaItem });
        }
        return;
      }

      if (img) {
        items.push({
          type: 'image',
          src: img.currentSrc || img.src,
          alt: img.alt || '',
          element: mediaItem,
        });
      }
    });

    return items;
  }

  function updateNavState() {
    zoomModal.classList.toggle('is-single', galleryItems.length <= 1);
  }

  function showGalleryItem(index) {
    if (!galleryItems.length) return;

    currentIndex = (index + galleryItems.length) % galleryItems.length;
    const item = galleryItems[currentIndex];

    if (item.type === 'video') {
      zoomVideo.src = item.src;
      zoomVideo.style.display = 'block';
      zoomImage.style.display = 'none';
    } else {
      zoomImage.src = item.src;
      zoomImage.alt = item.alt;
      zoomImage.style.display = 'block';
      zoomVideo.pause();
      zoomVideo.removeAttribute('src');
      zoomVideo.style.display = 'none';
    }

    updateNavState();
  }

  function openZoomAtIndex(index) {
    galleryItems = collectGalleryItems();
    if (!galleryItems.length) return;

    const safeIndex = Math.max(0, Math.min(index, galleryItems.length - 1));
    showGalleryItem(safeIndex);

    zoomModal.style.display = 'flex';
    zoomModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function navigate(direction) {
    if (galleryItems.length <= 1) return;
    showGalleryItem(currentIndex + direction);
  }

  function closeZoom() {
    zoomVideo.pause();
    zoomVideo.currentTime = 0;
    zoomVideo.removeAttribute('src');

    zoomModal.style.display = 'none';
    zoomModal.classList.remove('is-open', 'is-single');
    document.body.style.overflow = '';
    galleryItems = [];
    currentIndex = 0;
  }

  document.addEventListener('click', function (e) {
    const mediaItem = e.target.closest('.product__media-item');
    if (!mediaItem) return;

    const img = mediaItem.querySelector('.product__media img');
    const video = mediaItem.querySelector('video');
    if (!img && !video) return;

    e.preventDefault();
    e.stopPropagation();

    const header = document.querySelector('.header');
    if (header) header.classList.remove('menu-open');

    document.querySelectorAll('.header__menu-item--has-dropdown').forEach(function (dropdown) {
      dropdown.classList.remove('open');
    });

    galleryItems = collectGalleryItems();
    let startIndex = galleryItems.findIndex(function (item) {
      return item.element === mediaItem;
    });
    if (startIndex < 0) startIndex = 0;

    openZoomAtIndex(startIndex);
  });

  prevButton.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    navigate(-1);
  });

  nextButton.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    navigate(1);
  });

  zoomModal.querySelector('.zoom-content').addEventListener('click', function (e) {
    e.stopPropagation();
  });

  zoomModal.addEventListener('click', function (e) {
    if (e.target === zoomModal || e.target.classList.contains('zoom-overlay')) {
      closeZoom();
    }
  });

  zoomModal.querySelector('.zoom-close').addEventListener('click', function (e) {
    e.stopPropagation();
    closeZoom();
  });

  document.addEventListener('keydown', function (e) {
    if (zoomModal.style.display !== 'flex') return;

    if (e.key === 'Escape') {
      closeZoom();
      return;
    }

    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      navigate(-1);
      return;
    }

    if (e.key === 'ArrowRight') {
      e.preventDefault();
      navigate(1);
    }
  });

  zoomModal.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) return;
    touchStartX = e.touches[0].clientX;
  }, { passive: true });

  zoomModal.addEventListener('touchend', function (e) {
    if (!touchStartX || e.changedTouches.length !== 1) return;

    const deltaX = e.changedTouches[0].clientX - touchStartX;
    touchStartX = 0;

    if (Math.abs(deltaX) < 50) return;
    navigate(deltaX > 0 ? -1 : 1);
  }, { passive: true });
});
